/**
 * 멀티미디어 레퍼런스 서비스 코드
 * @enum {number}
 */
export const MULTIMEDIA_REFERENCE_SERVICE_CODE = {
    /** 수강신청 */
    'ENROLMENT': 100619
};